import styled from 'styled-components';

export const TrStyle = styled.tr`
  td {
    padding-top: 10px;
    padding-left: 5px;
    font-family: inherit;
    font-size: ${({ theme }) => {
      return theme.fonts.size.small;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    a {
      text-decoration: none;
      color: ${({ theme }) => {
        return theme.colors.primary;
      }};
    }
  }
`;
